import React, { useEffect, useRef, useState } from 'react';
import { Sidebar } from "primereact/sidebar";
import "../../assets/css/sidebar.css";
import { InputText } from "primereact/inputtext";
import chatIcon from "../../assets/images/chat-icon.svg";
import whatsappIcon from "../../assets/images/whatsapp-icon.svg";
import callIcon from "../../assets/images/call-icon.svg";
import { Accordion, AccordionTab } from "primereact/accordion";
import { withTranslation } from "react-i18next";
import AppLinks from "../../config.json";
import { staticSearchData } from "./data";
import { useSelector } from 'react-redux';
import DetectOutsideClicks from "./detect-outside.js"
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./navbar.scss";

const RightSidebar = ({ visibleRight, onClick, i18n, applicationName }) => {
  // const { language } = useSelector((data) => data.languageReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const language = i18n.language || "en";
  const showRTL = language === "ar";

  const [searchResults, setSearchResults] = useState([]);
  const [isSearchOpened, setIsSearchOpened] = useState(true);
  const [langSpecificResults, setLangSpecificResults] = useState([]);
  const [search, setSearch] = useState("");
  let mostAskedQuestions = [];

  if (applicationName === i18n.t("LEFTFOOTER.HEADING.MOTOR")) {
    mostAskedQuestions = [
      { id: "1", question: i18n.t("MotorFaq.question1"), answer: i18n.t("MotorFaq.answer1") },
      { id: "2", question: i18n.t("MotorFaq.question2"), answer: i18n.t("MotorFaq.answer2") },
      { id: "3", question: i18n.t("MotorFaq.question3"), answer: i18n.t("MotorFaq.answer3") },
      { id: "4", question: i18n.t("MotorFaq.question4"), answer: i18n.t("MotorFaq.answer4") },
    ];
  }

  const handleWhatsappClick = () => {
    window.open(AppLinks.WHATSAPP_LINK);
  };

  const handlePhoneNumberClick = () => {
    window.open("tel:800 124 9990");
  };
  const { t } = useTranslation()

  useEffect(() => {
    if (language) {
      if (language === "en") {
        const lSpecData = staticSearchData.filter((item) => item.lang === "EN");
        setLangSpecificResults(lSpecData);
      } else if (language === "ar") {
        const lSpecData = staticSearchData.filter((item) => item.lang === "AR");
        setLangSpecificResults(lSpecData);
      }
    }
  }, [language]);

  useEffect(() => {
    if (!search) return setSearchResults([]);

    const fSearch = staticSearchData.filter((item) =>
      item.keywords.split(",").some((keyword) =>
        keyword.toLowerCase().includes(search.toLowerCase())
      )
    );
    setSearchResults(fSearch);
  }, [search]);

  const searchArea = useRef(null);
  const isClickOutside = DetectOutsideClicks(searchArea);
  useEffect(() => {
    if (isSearchOpened) {
      isClickOutside && setIsSearchOpened(false);
    }
  }, [isClickOutside]);

  const handleActionClick = (url) => {
    setSearch(""); // Clear the search input
    if (url.includes("https")) {
      window.open(url);
    } else {
      window.location.assign(url);
    }
  };

  return (
    <Sidebar
      className={"right-side-bar-style" + (showRTL ? " ar" : "")}
      visible={visibleRight}
      position="right"
      onHide={onClick}
    >
      {/* <div className="white-layout">
        <div className="heading">{i18n.t("RIGHTSIDEBAR.NEEDHELP")}</div>
        <div className="grey-box">
          <div className="grey-box-title">{i18n.t("RIGHTSIDEBAR.HELPYOU")}</div>
          <span
            className={
              "p-input-icon-right input-text-style " + (showRTL ? "input-text-style-rtl" : "")
            }
          >
            {isSearchOpened ? (
              <React.Fragment>
                <span className={"p-input-icon-right input-text-style " + (showRTL ? "input-text-style-rtl" : "")}>
                  <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder={i18n.t("RIGHTSIDEBAR.LOOKING")} />
                </span>
                {search !== "" && (
                  <div className="searchResultBox">
                    <p className="fs-12 fw-800 search-ResultTitle">{t("navbar.results")}</p>
                    {searchResults.length === 0 ? (
                      <p className="fs-10 fw-400 search-ResultPara">{t("navbar.noResultFound")}</p>
                    ) : (
                      <React.Fragment>
                        <p className="fs-10 fw-400 search-ResultPara">
                          {t("navbar.search.found")} {searchResults.length} {t("navbar.search.res_for")}{" "}
                          <span>“</span>
                          <span className="results_color">{search}</span>
                          <span>”</span>
                        </p>
                        {searchResults.map((item, idx) => {
                          return (
                            <div className="d-flex justify-content-between resultContainer" key={idx}>
                              <div className="py-2">
                                <p className="fs-10 fw-400 result_Name m-0">{item.category}</p>
                              </div>
                              <div
                                className="py-2 resultContainer_action"
                                onClick={() => handleActionClick(item.webUrl)}
                              >
                                <p className="fs-10 fw-400 result_Title m-0">{item.action}</p>
                              </div>
                            </div>
                          );
                        })}
                      </React.Fragment>
                    )}
                  </div>
                )}
              </React.Fragment>
            ) : (
              <div></div>
            )}
          </span>
        </div>
        {mostAskedQuestions && mostAskedQuestions.length > 0 && (
          <div className="most-asked">{i18n.t("RIGHTSIDEBAR.MOSTQUESTIONS")}</div>
        )}
        <div className={showRTL ? "most-asked-layout-rtl" : "most-asked-layout"}>
          {mostAskedQuestions.map((item) => (
            <Accordion multiple collapseIcon="pi pi-minus" expandIcon="pi pi-plus" key={item.id}>
              <AccordionTab header={item.question}>
                <div className="most-asked-box">
                  <div className="most-asked-open">{item.answer}</div>
                </div>
              </AccordionTab>
            </Accordion>
          ))}
        </div>
      </div> */}
      <div className="grey-layout">
        <div className="find-answer">
          {i18n.t("RIGHTSIDEBAR.FINDANSWER")} <br /> {i18n.t("RIGHTSIDEBAR.CONTACT")}
        </div>
        <div className="row">
          <div className="col-md-6 c-pointer" onClick={handleWhatsappClick}>
            <div className="d-flex">
              <div>
                <img src={chatIcon} alt="Chat Icon" />
              </div>
              <div className={showRTL ? "me-12" : "ms-12"}>
                <div className="chat-with">{i18n.t("RIGHTSIDEBAR.CHAT")}</div>
                <div className="live-chat">{i18n.t("RIGHTSIDEBAR.LIVECHAT")}</div>
              </div>
            </div>
          </div>
          <div className="col-md-6 pe-0 c-pointer" onClick={handleWhatsappClick}>
            <div className="d-flex">
              <div>
                <img src={whatsappIcon} alt="Chat Icon" />
              </div>
              <div className={showRTL ? "me-12" : "ms-12"}>
                <div className="chat-with">{i18n.t("RIGHTSIDEBAR.WHATSAPP")}</div>
                <div className="live-chat">{i18n.t("RIGHTSIDEBAR.WHATSAPPNUMBER")}</div>
                <div className="chat-with">{i18n.t("RIGHTSIDEBAR.CHATNUMBER")}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="row my-2 c-pointer" onClick={handlePhoneNumberClick}>
          <div className="col-md-6">
            <div className="d-flex">
              <div>
                <img src={callIcon} alt="Chat Icon" />
              </div>
              <div className={showRTL ? "me-12" : "ms-12"}>
                <div className="chat-with">{i18n.t("RIGHTSIDEBAR.CALLCENTER")}</div>
                <div className="live-chat">{i18n.t("RIGHTSIDEBAR.CALLCENTERNUMBER")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
};

export default withTranslation()(RightSidebar);
